
export default {
  props: {
    concert: {
      type: Object,
      required: true,
    },
  },
};
